module.exports = __webpack_public_path__ + "img/azxy10_icon.8e3ac75b.png";